import React, { useState, useEffect, useMemo, useRef } from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';

let DefaultIcon = L.icon({
    iconUrl: icon,
    shadowUrl: iconShadow
});

L.Marker.prototype.options.icon = DefaultIcon;

function ProfileMapComponent({ venue }) {
    const lagosPosition = useMemo(() => [6.6053, 3.3499], []);
    const abujaPosition = useMemo(() => [9.0676, 7.4328], []);

    const [mapCenter, setMapCenter] = useState(lagosPosition);
    const [mapZoom, setMapZoom] = useState(11);
    const mapRef = useRef(null); // Create a ref for the map
 
    useEffect(() => {
        if (venue === "Oluwalogbon House, Testing Ground Bus Stop, Obafemi Awolowo Way, Ikeja, Lagos") {
            setMapCenter(lagosPosition);
            setMapZoom(16);
        } else if (venue === "6th floor, Nigeria Reinsurance Corporation building, Plot 784A Herbert Macaulay Way, North, Abuja." || venue === "2nd floor Puskin mall, Samuel Mafuyi Street, Opposite AA Rano, Jabi, Abuja") {
            setMapCenter(abujaPosition);
            setMapZoom(16);
        } else {
            setMapCenter(lagosPosition);
            setMapZoom(11);
        }
    }, [venue, lagosPosition, abujaPosition]);

    useEffect(() => {
        if (mapRef.current) {
            mapRef.current.setView(mapCenter, mapZoom); // Set the view when center or zoom changes
        }
    }, [mapCenter, mapZoom]);

    let markerToRender = null;

    if (venue === "Oluwalogbon House, Testing Ground Bus Stop, Obafemi Awolowo Way, Ikeja, Lagos") {
        markerToRender = (
            <Marker position={lagosPosition}>
                <Popup>
                    <b>Lagos Office</b><br />
                    Inside Eridan Place, Oluwalogbon House,<br />
                    Testing Ground Bus Stop, Obafemi Awolowo Way, Ikeja, Lagos
                </Popup>
            </Marker>
        );
    } else if (venue === "6th floor, Nigeria Reinsurance Corporation building, Plot 784A Herbert Macaulay Way, North, Abuja." || "2nd floor Puskin mall, Samuel Mafuyi Street, Opposite AA Rano, Jabi, Abuja") {
        markerToRender = (
            <Marker position={abujaPosition}>
                <Popup>
                    <b>Abuja Office</b><br />
                    2nd floor Puskin mall,<br />
                    Samuel Mafuyi Street, Jabi, Abuja
                </Popup>
            </Marker>
        );
    }

    return (
        <MapContainer center={mapCenter} zoom={mapZoom} style={{ height: '300px', width: '100%' }} ref={mapRef}>
            <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            {markerToRender}
        </MapContainer>
    );
}

export default ProfileMapComponent;